export default (window.GemQuery || jQuery) as JQueryStatic;
